import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { MdAccessTime, MdLocationOn } from "react-icons/md";
import { toast } from "react-toastify";
import { searchServiceablePincodesAPI } from "services/user-controllers/onboardingController";
import "./Onboarding.scss";

const coverageText = (states = []) =>
  states.length <= 3 ? states.join(", ") || "—" : `${states.slice(0, 3).join(", ")} +${states.length - 3} more`;

// Pincodes situated in one zone (opened from a zone card or a matrix header)
const ZonePincodesModal = ({ zone, onClose }) => {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 20;

  const load = async (nextPage) => {
    try {
      const { data } = await searchServiceablePincodesAPI({ zoneId: zone.id, page: nextPage, limit });
      if (data?.code === 200) {
        setRows(data.data.pincodes || []);
        setTotal(data.data.totalCount || 0);
        setPage(nextPage);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load pincodes");
    }
  };

  useEffect(() => {
    load(1);
    // eslint-disable-next-line
  }, [zone.id]);

  return (
    <div className="ob_modal_overlay" onClick={onClose}>
      <div className="ob_modal" onClick={(e) => e.stopPropagation()}>
        <h4>Situated Pincodes — {zone.name}</h4>
        <p className="ob_note">
          {coverageText(zone.states)} · {total} pincode{total === 1 ? "" : "s"}
        </p>
        <div className="ob_modal_table">
          <table className="ob_charges">
            <thead>
              <tr>
                <th>Pincode</th>
                <th>City</th>
                <th>State</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.pincode}</td>
                  <td>{r.city}</td>
                  <td>{r.state}</td>
                  <td>
                    <span className={`tag ${r.status === "serviceable" ? "ok" : "oda"}`}>{r.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {total > limit && (
          <div className="ob_pin_pager">
            <span />
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              pageRangeDisplayed={5}
              activePage={page}
              onChange={load}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              itemClassLast={"last_page next"}
              itemClassFirst={"first_page prev"}
            />
          </div>
        )}
        <div className="ob_modal_actions">
          <button type="button" className="ob_btn outline" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// "Regional Delivery TAT & Coverage": one card per zone
const ZoneCoverage = ({ zones, onSelect }) => (
  <div className="ob_coverage">
    <div className="ob_coverage_head">
      <h5 className="ob_section_title">
        <MdAccessTime /> Regional Delivery Turnaround Time (TAT) &amp; Coverage
      </h5>
      <span>Click any zone to view pincodes</span>
    </div>
    <div className="ob_coverage_grid">
      {zones.map((z) => (
        <button key={z.id} type="button" className="ob_zone_card" onClick={() => onSelect(z)}>
          <div>
            <strong>
              <MdLocationOn /> {z.name}
            </strong>
            <p>{coverageText(z.states)}</p>
            <span className="link">View Pincodes →</span>
          </div>
        </button>
      ))}
    </div>
  </div>
);

export { ZonePincodesModal };
export default ZoneCoverage;
